<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      playsinline
      webkit-playsinline
    ></video>
  </div>
</template>

<script>
import videoJS from 'video.js';
import 'video.js/dist/video-js.css';

// CRITICAL: Configure VHS globally BEFORE any player instance
// Force VHS to override native HLS on Safari/iOS
videoJS.options.html5 = videoJS.options.html5 || {};
videoJS.options.html5.vhs = videoJS.options.html5.vhs || {};
videoJS.options.html5.vhs.overrideNative = true;
videoJS.options.html5.nativeVideoTracks = false;
videoJS.options.html5.nativeAudioTracks = false;
videoJS.options.html5.nativeTextTracks = false;

export default {
  name: 'QVideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    accessToken: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      player: null,
      videoSrc: null,
    };
  },
  mounted() {
    // Set up VHS auth headers globally before player init
    if (this.accessToken) {
      // Try both old and new API just in case
      const xhrSetup = (options) => {
        if (!options.headers) {
          options.headers = {};
        }
        options.headers.Authorization = `Bearer ${this.accessToken}`;
        return options;
      };

      // New API (Video.js 8.x)
      if (videoJS.Vhs && videoJS.Vhs.xhr) {
        videoJS.Vhs.xhr.onRequest = xhrSetup;
      }

      // Old API (fallback)
      if (videoJS.Vhs && videoJS.Vhs.xhr) {
        videoJS.Vhs.xhr.beforeRequest = xhrSetup;
      }
    }

    // Initialize player
    this.player = videoJS(
      this.$refs.videoPlayer,
      this.options,
      // function onPlayerReady() {
      //   // Check if VHS is available
      //   const tech = this.tech({ IWillNotUseThisInPlugins: true });
      //   console.log('Tech object:', tech);
      //   console.log('Has VHS?', !!tech.vhs);
      // },
    );

    // Log any errors
    this.player.on('error', () => {
      const error = this.player.error();
      console.error('Video.js error:', error);
    });

    // Log when source is loaded
    // this.player.on('loadstart', () => {
    //   console.log('Load started - Using tech:', this.player.techName_);
    //   const tech = this.player.tech({ IWillNotUseThisInPlugins: true });
    //   console.log('Tech has VHS?', !!tech.vhs);
    // });
  },
  beforeUnmount() {
    if (this.player) this.player.dispose();
  },
  methods: {
    async updateVideo(video) {
      this.player.src(video.sources);
    },
  },
};
</script>

<style scoped>
.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 56.25% !important;
}
</style>
